<template>
  <t-layout class="page">
    <div class="info">
      <div class="item" @click="toShopCoupon">商户优惠券</div>
    </div>
  </t-layout>
</template>

<script>
import wx from 'weixin-js-sdk'

export default {
  name: 'findView',
  components: {},
  data() {
    return {}
  },
  created() {
    gio('track', 'page_view', {})
    this.getAll()
  },
  methods: {
    getAll() {
      // this.$store.commit(
      //   'setUserToken',
      //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjcwMDcyLCJ0cyI6MTY2OTc5ODY1OCwiZXhwIjoxNjY5Nzk4NjU4fQ.KHTioAFv_059eHUmOg2wrjW2-EdiVjoU-noL3Yx6NUg'
      // )
      this.$api.find.getAll().then(res => {
        console.log('res', res)

        this.$store.commit('setTitle', '双十一海旅免税')
      })
    },

    toShopCoupon() {
      this.$router.push({
        name: 'shopCoupon'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  .info {
    font-size: 28rpx;
  }
}
</style>
